import React from 'react';

import Measure, { ContentRect } from 'react-measure';
import styled, { css } from 'styled-components';

import { ISanityImage } from '@rbi-ctg/menu';
import { OfferBadges } from 'components/offer-badges';
import Picture from 'components/picture';
import { IImageFragment } from 'generated/sanity-graphql';

import { OfferPictureContainer } from './offer-picture-container.styled';
import theme from './theme';

const containerStyles = css`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;

  background-color: ${Styles.color.background};
`;
export const Container = styled.div`
  ${containerStyles}
`;

const UnconstrainedHeightContainer = styled.div`
  ${containerStyles}
  height: auto;
`;

interface IMeasuredContainerProps {
  onResize: (contentRect: ContentRect) => void;
}

export const MeasuredContainer: React.FC<IMeasuredContainerProps> = ({ children, onResize }) => (
  <Measure onResize={onResize}>
    {({ measureRef }) => (
      <UnconstrainedHeightContainer ref={measureRef}>{children}</UnconstrainedHeightContainer>
    )}
  </Measure>
);

export const BackgroundPicture = styled(Picture)`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

const StyledPicture = styled(Picture)`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

interface IOfferPictureProps {
  image: ISanityImage | IImageFragment;
  alt: string;
  objectFitContain?: boolean;
}

export const OfferPicture: React.FC<IOfferPictureProps> = ({
  image,
  alt,
  objectFitContain = true,
}) => (
  <OfferPictureContainer>
    <StyledPicture alt={alt} image={image} objectFitContain={objectFitContain} />
  </OfferPictureContainer>
);

export const ImgBgContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 1rem;
`;

export const OfferInfoContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;

  ${Styles.desktop`
    width: 65%;
  `}
`;

export const Name = styled.h2`
  margin: 0;
  margin-bottom: 8px;
  text-transform: ${theme.headingTextTransform};
  font-family: ${Styles.fontFamily.base};
  color: ${Styles.color.black};
  font-size: 1.25rem;
  text-align: center;
  line-height: 1.2;

  ${Styles.desktop`
    margin-bottom: 12px;
    font-size: 2.25rem;
  `}
`;

export const Description = styled.p`
  margin: 0;
  margin-bottom: 24px;
  font-family: ${Styles.fontFamily.body};
  text-align: center;
  font-size: 0.8rem;
  line-height: 1.3rem;
  color: ${theme.descriptionColor};

  ${Styles.desktop`
    font-size: 1rem;
    line-height: 1.4rem;
  `}
`;

export const ErrorMessage = styled.p`
  margin: 0;
  margin-top: 12px;
  font-size: 0.8rem;
  color: ${Styles.color.error};
  text-align: center;

  ${Styles.desktop`
    margin-top: 16px;
  `}
`;

export const StyledOfferBadges = styled(OfferBadges)`
  justify-content: flex-end;
  &:not(:empty) {
    margin: 0;
    margin-bottom: 24px;
  }
`;

export const FavoriteButton = styled.div`
  position: absolute;
  z-index: 10;
  right: 0;
  margin: 0.8rem 0.8rem 0 0;
  padding: 0.375rem;
`;

export const LoadingWrapper = styled.div`
  height: 2rem;
`;
